<template>
  <div class="content">
    <div class="banner-wrapper">
      <!-- <img :src="require("@/assets/imgs/album-banner2.jpg")" alt=""> -->
    </div>
    <div class="nav-wrapper">
      <div class="nav">
        <router-link :to="{ name: 'transfer-contest' }" class="nav-item">我的比赛</router-link>
        <router-link :to="{ name: 'transfer-training' }" class="nav-item active">我的练习</router-link>
      </div>
    </div>
    <div class="info-wrapper">
      <div class="info-item">
        <div class="num">{{ total_num }}</div>
        <div class="desc">活动已挑战</div>
      </div>
      <div class="info-item">
        <div class="num">{{ pass_num }}</div>
        <div class="desc">活动已通过</div>
      </div>
      <div class="info-item">
        <div class="num">
          {{
            pass_num / total_num
              ? Math.round((pass_num / total_num) * 100) 
              : 0
          }}%
        </div>
        <div class="desc">通过率</div>
      </div>
    </div>
    <div class="training-wrapper">
      <el-table style="width: 100%" border :data="training" header-row-class-name="header-table">
        <el-table-column prop="paper_title" label="活动名称" width="180">
        </el-table-column>
        <el-table-column label="提交时间" width="180">
          <template slot-scope="scope">{{
            common.date("Y-m-d H:i", scope.row.submit_time)
          }}</template>
        </el-table-column>
        <el-table-column prop="course_title" label="所属应用"> </el-table-column>
        <el-table-column width="80" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.is_read === 1 && scope.row.is_pass == 1" style="color:#409eff;">已通过</span>
            <span v-if="scope.row.is_read === 1 && scope.row.is_pass != 1" style="color:red;">未通过</span>
            <span v-if="scope.row.is_read !== 1" style="color:#409eff">待批阅</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @current-change="pageChange" background layout="total, prev, pager, next" :total="total_num" :page-size="pageSize" v-show="total_num / pageSize > 1"
        v-if="total_num / pageSize > 1" hide-on-single-page></el-pagination>
    </div>
  </div>
</template>

<script>
import { getTransferTraining } from "@/api/apps";
export default {
  data() {
    return {
      training: null,
      pageSize: 10,
      pageNo: 1,
      total_num: 0,
      pass_num: 0
    };
  },
  created() {
    this.handle();
  },

  methods: {
    handle() {
      var params = {
        pageSize: this.pageSize,
        pageNo: this.pageNo
      };
      getTransferTraining(params).then(response => {
        this.training = response.data.data;
        this.total_num = response.data.info.total_num;
        this.pass_num = response.data.info.pass_num;
      });
    },
    pageChange(val) {
      this.pageNo = val;
      this.handle();
    }
  }
};
</script>

<style scoped lang="less">
.banner-wrapper {
  height: 200px;
  background: url("../../assets/imgs/album-banner2.jpg") center no-repeat;
}
.nav-wrapper {
  background-color: #e7eef3;
  overflow: hidden;
  display: flex;
  justify-content: center;
  .nav {
    width: 300px;
    height: 50px;
    display: flex;

    .nav-item {
      width: 100px;
      line-height: 50px;
      font-size: 16px;
      text-align: center;
      cursor: pointer;
    }
    .active {
      color: #409eff;
      border-bottom: 2px solid #409eff;
    }
  }
}
.info-wrapper {
  width: 600px;
  margin: 20px auto 30px;
  display: flex;

  .info-item {
    width: 200px;
    border-right: 1px #aaaaaa solid;
    box-sizing: border-box;
    height: 60px;
    text-align: center;
    .num {
      font-size: 28px;
      color: #333333;
      padding-bottom: 10px;
    }
    .desc {
      color: #7f7f7f;
    }
  }
  .info-item:last-child {
    border: none;
  }
}
.training-wrapper {
  max-width: 1000px;
  margin: 0 auto;
  /deep/ .header-table th {
    background: #f2f2f2;
  }
  /deep/ td {
    border: none;
  }
  /deep/ th {
    border: none;
  }
  .el-table {
    margin-bottom: 20px;
  }
}
</style>
